import { gql } from "@apollo/client";

export const CREATE_LEVEL = gql`
  mutation CreateLevel($input: CreateLevelInput) {
    createLevel(input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GET_LEVEL_PAGINATION = gql`
  query GetLevelPagination($page: Int, $limit: Int, $pagination: Boolean, $keyword: String) {
  getLevelPagination(page: $page, limit: $limit, pagination: $pagination, keyword: $keyword) {
    data {
      _id
      level_name
      remark
      after_finish
      next_level_id {
        level_name
        _id
      }
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`;

export const UPDATE_LEVEL = gql`
  mutation UpdateLevel($id: ID, $input: CreateLevelInput) {
    updateLevel(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const DELETE_LEVEL = gql`
  mutation DeleteLevel($id: ID) {
    deleteLevel(_id: $id) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;
